module.exports = __webpack_public_path__ + "img/one.10894054.png";